import styled from 'styled-components';
import { getColor, getColorShade, getSizeBy } from '../../../../../src/styled/utils';
import { ListItem } from '../../../list-item';
import { Body2, Subtitle1 } from '../../../typography';
import AccordionIcon from '../../../icon/special/accordion-styled';
export const SidebarWrap = styled.ul `
  height: 100%;
  padding: 0 ${getSizeBy(6)};
  overflow: auto;
  background-color: ${getColor('surface')};
  box-shadow: inset -0.5px 0 0 rgb(16 11 40 / 0.14);
`;
export const StyledListItem = styled(ListItem) `
  display: flex;
  justify-content: space-between;

  & :hover {
    cursor: pointer;
  }
`;
export const StyledListSubItem = styled(ListItem) `
  display: flex;
  justify-content: space-between;
  padding-left: ${getSizeBy(7.5)};

  & :hover {
    cursor: pointer;
  }
`;
export const CountWrap = styled(Subtitle1) `
  flex: 0 0 auto;
  margin-left: ${getSizeBy()};
  padding: 0 ${getSizeBy()};
  background: ${getColorShade('onSurface', 'pressed')};
  border: 2px solid ${getColor('surface')};
`;
export const StyledTitle = styled(Body2) `
  color: ${({ activeDirectory }) => activeDirectory ? getColor('primary') : getColorShade('onSurface', 'mediumEmphasis')};
`;
export const StyledAccordionIcon = styled(AccordionIcon) `
  flex: 0 0 auto;
`;
